import MonthPanel from '@components/ui/date-time/components/month-panel';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@icon';
import { Calendar, CalendarMonth } from '@rehookify/datepicker';
import React from 'react';
import IconButton from '../../../../icon-button';
import CalendarHeader from '../../../components/calendar-header';
import DateTitle from '../../../components/date-title';
import { TPropsGetters } from '../../../date-time.types';
import { TPanelMode } from '../../../date-time.utils';

interface DatePickerMonthsProps {
  mode?: TPanelMode;
  setPanelMode: React.Dispatch<React.SetStateAction<TPanelMode>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onChange?: (dates: Date[]) => void;
  calendars: Calendar[];
  months: CalendarMonth[];
  propGetters: TPropsGetters;
}

const DatePickerMonths: React.FunctionComponent<DatePickerMonthsProps> = ({
  mode,
  setOpen,
  setPanelMode,
  onChange,
  calendars,
  propGetters,
  months,
}) => {
  return (
    <div>
      <CalendarHeader
        left={
          <IconButton
            Icon={ArrowLeftOutlined}
            size="small"
            variant="ghost-tertiary"
            {...propGetters.previousMonthButton()}
          />
        }
        right={
          <IconButton
            Icon={ArrowRightOutlined}
            size="small"
            variant="ghost-tertiary"
            {...propGetters.nextMonthButton()}
          />
        }
      >
        <DateTitle month={calendars[0].year} onMonthClick={() => setPanelMode('year')} />
      </CalendarHeader>
      <MonthPanel
        months={months}
        monthButton={propGetters.monthButton}
        config={{
          onClick: (_, d) => {
            if (mode === 'date') {
              setPanelMode('date');
            } else if (mode === 'month') {
              if (d) {
                onChange?.([d]);
              }

              setOpen(false);
            } else {
              setOpen(false);
            }
          },
        }}
      />
    </div>
  );
};

export default DatePickerMonths;
